<div
   class="flex h-[30px] tablet:h-[55px] !text-[5px] tablet:!text-[10px] desktop:!text-xs px-[2px] tablet:px-2 desktop:px-4 flex-row gap-2 tablet:gap-8 bg-app-primary-1 text-white overflow-hidden footer"
>
   <div class="flex items-center justify-between gap-2 desktop:gap-11">
      <div
         style="background-size: 100%"
         class="w-[70px] desktop:w-[165px] tablet:w-[130px] h-6 desktop:h-11 bg-footer-left-logo bg-no-repeat bg-center"
      ></div>

      <span class="whitespace-pre-line tablet:whitespace-nowrap">© {{ currentYear }} PNO - All rights reserved</span>
   </div>

   <div class="flex flex-row flex-1 gap-1 justify-between">
      <div class="flex gap-2 items-center tablet:gap-5 desktop:gap-8">
         <div class="h-[15%] w-[0.5px] bg-white hidden desktop:block"></div>

         <p-button
            styleClass="hover:opacity-50 footer-btn-no-bg !border-none"
            label="Disclaimer"
            (onClick)="goToDiscalimer()"
         ></p-button>

         <div class="w-[0.5px] bg-white h-[15%]"></div>

         <p-button
            styleClass="hover:opacity-50 footer-btn-no-bg !border-none"
            label="Cookie Policy"
            (onClick)="goToCookiePolicy()"
         ></p-button>

         <div class="w-[0.5px] bg-white h-[15%]"></div>

         <p-button
            styleClass="hover:opacity-50 footer-btn-no-bg !border-none"
            label="Privacy statement "
            (onClick)="goToPrivacy()"
         ></p-button>

         <div class="w-[0.5px] bg-white h-[15%]"></div>

         <p-button
            styleClass="hover:opacity-50 footer-btn-no-bg !border-none"
            label="Terms and conditions "
            (onClick)="goToTermsAndCondition()"
         ></p-button>
      </div>

      <div class="flex justify-end gap-3 items-center pr-0 tablet:pr-4">
         <div
            style="background-size: 100%"
            class="w-[50px] tablet:w-[130px] desktop:w-[165px] h-[20px] tablet:h-[30px] desktop:h-[35px] bg-footer-right-logo bg-no-repeat bg-center"
         ></div>
      </div>
   </div>
</div>
